<div class="r-element r-label r-label-pos-{{ labelPos }} {{ e2e ? '--js-element-' + e2e : '' }}">
    <div *ngIf="label" class="label-text">{{ label }}<span *ngIf="required"> *</span></div>

    <ng-content></ng-content>
</div>
